import { render, staticRenderFns } from "./training-form-page.vue?vue&type=template&id=32636455&"
import script from "./training-form-page.vue?vue&type=script&lang=js&"
export * from "./training-form-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports